import "core-js/modules/esnext.iterator.map.js";
import { isFunction, isObject, serializeObject } from "../../mcn-helpers";
import JsonArrayMapper from "./JsonArrayMapper";
import JsonMapperModuleResolver from "./JsonMapperModuleResolver";
export default class JsonMapper {
  constructor() {}
  map(jsonData, attributes = {}) {
    try {
      if (!isObject(attributes) || !isObject(jsonData)) {
        return;
      }
      for (let [key, value] of Object.entries(attributes)) {
        /*                if (key === 'domain_title') {
                            console.log('key', key)
                            console.log('attributes', attributes)
                            console.log('value', value)
                            console.log('json', jsonData)
                            console.log('jsonContent', jsonData[key])
                            console.log('isObject(jsonContent)', isObject(jsonData[key]))
                        }*/

        if (!jsonData.hasOwnProperty(key)) {
          continue;
        }
        if (isFunction(value)) {
          let jsonContent = jsonData[key];
          // this is for when the model is just a regular function to get the actual model
          if (value === JsonMapperModuleResolver || JsonMapperModuleResolver.isPrototypeOf(value)) {
            value = value.getResolvedModule(jsonContent);
            if (!isFunction(value)) {
              continue;
            }
          }
          this[key] = isObject(jsonContent) || Array.isArray(jsonContent) ? JsonMapper.isPrototypeOf(value) || JsonArrayMapper.isPrototypeOf(value) ? new value(jsonContent) : Array.isArray(jsonContent) ? jsonContent.map(jsonContentItem => serializeObject(jsonContentItem, value)) : serializeObject(jsonContent, value) : jsonContent;
          continue;
        }
        this[key] = jsonData[key];
      }
    } catch (e) {
      console.log('json mapped error', e);
    }
    return this;
  }
  getAttribute(key) {
    return this[key];
  }
  setAttribute(key, value) {
    return this[key] = value;
  }
}